module.exports = __webpack_public_path__ + "img/ico-main.a1c45979.svg";